import React from "react";


/*
    icons in this file are obtained from Material icons under Apache License
    https://fonts.google.com/icons
    https://github.com/google/material-design-icons
    https://github.com/google/material-design-icons/blob/master/LICENSE

*/


export const dark_light_triangle = (
    <svg className="swap-theme-icon" fill="currentColor" height="30" width="30" viewBox="0 0 48 48">
        <path d="M20 38 6 24l14-14Zm8 0V10l14 14Zm2.75-6.65L38.1 24l-7.35-7.35Z"/>
    </svg>
);